export default {"src":"/_next/static/media/info-icon.06814ea5.svg","height":513,"width":513};